export const load = () => ({
	title: 'Neighbors Playing Loud Music During the Day?',
	showTitle: true,
});
